export const WALLET_CONNECT_PROJECT_ID = '982077ac6b911c7270812e5545e16b60'
